import {colorSwatch} from '../utils/colorSwatch.js';
import {MenuButton} from './menu-button.js';
import {formatNumber} from '../../utils/Utils.js';
import {UiTexturesManager} from './ui-textures-manager.js';

export const CoinButton = (props: {price: number; onClick: () => void}) => {
    return (
        <MenuButton
            width={150}
            height={60}
            color={colorSwatch.SpendCoinsButton}
            icon={UiTexturesManager.instance.coinIconSmall}
            fontSize={24}
            onClick={props.onClick}
        >
            {formatNumber(props.price)}
        </MenuButton>
    );
};
